// When the Hub runs inside the Mac/Windows app, notifications, the unread badge,
// links and downloads go through the app. In a browser tab nothing here runs.

type Tauri = {
  core: { invoke: (cmd: string, args?: Record<string, unknown>) => Promise<unknown> };
  event: { listen: (name: string, cb: (e: { payload: any }) => void) => Promise<() => void> };
  opener?: { openUrl: (url: string) => Promise<void> };
  window: { getCurrentWindow: () => { startDragging: () => Promise<void> } };
};

const tauri = (): Tauri | null => (window as any).__TAURI__ ?? null;
export const isDesktop = () => !!tauri();

export function desktopNotify(title: string, body: string, path: string, group?: string) {
  tauri()?.core.invoke("notify", { title, body, route: path, group: group ?? null }).catch(() => {});
}

export function desktopBadge(count: number) {
  tauri()?.core.invoke("set_badge", { count }).catch(() => {});
}

export function startDesktop(open: (path: string) => void, toast: (s: string) => void) {
  const t = tauri();
  if (!t) return;
  document.documentElement.classList.add("desktop");
  if (/Mac/.test(navigator.platform)) document.documentElement.classList.add("mac");

  // A notification was clicked: open its chat.
  t.event.listen("hub://open", (e) => open(String(e.payload)));
  // A new version of the app is installed: offer the restart (it also happens next time the window closes).
  t.event.listen("hub://update-ready", (e) => {
    if (document.querySelector(".upd")) return;
    const b = document.createElement("button");
    b.className = "upd";
    b.textContent = `Version ${e.payload} is ready · Restart`;
    b.onclick = () => t.core.invoke("restart_now").catch(() => {});
    document.body.appendChild(b);
  });
  t.event.listen("hub://downloaded", (e) => {
    const [ok, name] = e.payload as [boolean, string];
    toast(ok ? `Saved to Downloads: ${name}` : "Download failed");
  });

  // The strip along the top moves the window (the Mac title bar is hidden).
  const strip = document.createElement("div");
  strip.className = "dragbar";
  strip.addEventListener("mousedown", (e) => { if (e.button === 0 && e.detail === 1) t.window.getCurrentWindow().startDragging().catch(() => {}); });
  document.body.appendChild(strip);

  // ⌘R / Ctrl+R reloads, like in a browser.
  addEventListener("keydown", (e) => { if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "r") { e.preventDefault(); location.reload(); } });

  // Links to other sites open in the normal browser.
  document.addEventListener("click", (e) => {
    const a = (e.target as HTMLElement).closest?.("a") as HTMLAnchorElement | null;
    if (!a || !a.href) return;
    const url = new URL(a.href, location.href);
    if (url.origin === location.origin) return;
    e.preventDefault();
    (t.opener ? t.opener.openUrl(url.href) : Promise.reject()).catch(() => window.open(url.href, "_blank"));
  }, true);
}
